import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { OrdersPageContent } from '../../components/Orders';

const OrdersPage = () => {
  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.Content>
          <OrdersPageContent />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};

export default OrdersPage;
